/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import classes from './RequirementTag.module.scss';

const RequirementTag = ({ className, children, count, type }) => {
  return (
    <span className={cn(classes.wrapper, classes[`type_${type}`], className)}>
      <span>{children}</span>
      <span>{count}</span>
    </span>
  );
};

export default RequirementTag;
